import { addDoc, collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../../../firebase";
import { STUDIO_PROJECT_AUDIT_COLLECTION } from "../constants";

/**
 * Project management audit trail — separate from Firestore Admin `admin_logs`.
 */
export async function logProjectAudit({
  action,
  projectId,
  projectName,
  adminUid,
  adminName,
  details = {},
}) {
  await addDoc(collection(db, STUDIO_PROJECT_AUDIT_COLLECTION), {
    action,
    projectId: projectId || null,
    projectName: projectName || "",
    adminUid: adminUid || "",
    adminName: adminName || "",
    details,
    dateTime: new Date().toISOString(),
    device: typeof navigator !== "undefined" ? navigator.userAgent : "",
  });
}

export async function fetchProjectAuditLogs({ projectId, max = 100 } = {}) {
  const snap = await getDocs(
    query(collection(db, STUDIO_PROJECT_AUDIT_COLLECTION), orderBy("dateTime", "desc"), limit(max))
  );
  let rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  if (projectId) rows = rows.filter((r) => r.projectId === projectId);
  return rows;
}
